import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Components
import Forsi from '../Forsi'
import Customer from '../Customer'
import RegistrationNumber from '../RegistrationNumber'
import OrderTypes from '../OrderTypes'
import Brand from '../Brand'
import ChassisNumber from '../ChassisNumber'
import FileArea from '../FileArea'
import Estimation from '../Estimation'

import MarkImage from '../MarkImage'
import Complaint from '../Complaint'

// Actions
import {
  createOrder,
  getOrderVehicleData
} from '../../../../actions/orders'

// Utils
import { translation } from '../../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../../utils/auth'

class NewPaintDraft extends Component {
  constructor (props) {
    super(props)

    this.state = {
      InsuranceCompanies: [],

      isLoading: false,

      CustomerId: 0,

      RegNumber: '',
      ChassisNumber: '',
      BrandOriginal: '', // brandname,
      ExtraData: {},

      OrderType: '0',

      fileContainerId: null,
      images: [],
      files: [],
      activeImage: {},

      evaluationAllowed: true,
      Estimation: '0',
      Estimation_comment: '',

      orderdata: {},
      listingID: '0'
    }

    this.submitOrder = this.submitOrder.bind(this)
    this.createOrder = this.createOrder.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.updateState = this.updateState.bind(this)
  }

  componentDidMount () {
    this.props.updateModal({
      bottomBarProps: {
        actionLabelText: translation('21'),
        onActionClick: this.submitOrder
      }
    })

    let ownShopCustomer = this.props.customers.find(cust => cust.IsOwnShop === true)
    if (ownShopCustomer !== undefined) {
      this.setState({
        CustomerId: ownShopCustomer.CustomerId
      })
    }
  }

  setErrors (errors) {
    this.setState(errors)
    let el = ReactDOM.findDOMNode(this.refs.addorderpopup).parentNode
    el.scrollTop = 0
  }

  submitOrder (e) {
    e.preventDefault()

    this.setState({ isLoading: true, error: '' })

    // If user filled in regnumber, but chassis is empty, try to look up data before continuing.
    if (this.state.RegNumber !== null && this.state.RegNumber !== '' &&
      (this.state.ChassisNumber === null || this.state.ChassisNumber === '') &&
      hasSubscriptionPermission(this.props.auth, 10)) {
      this.setState({ ExtraData: {} })

      this.props.getOrderVehicleData(this.state.RegNumber, 'RegNumber').then(res => {
        if (res.data.BrandOriginal !== null) {
          this.setState({
            ChassisNumber: res.data.ChassisNumber,
            BrandOriginal: res.data.BrandName,
            ExtraData: res.data
          }, () => {
            this.createOrder()
          })
        }
      }, () => {
      })
      this.createOrder()
    } else {
      this.createOrder()
    }
  }

  createOrder () {
    if (this.state.isLoading) return

    let customerId = 0
    if (this.props.auth.user.CustomerId === '-1') {
      customerId = parseInt(this.state.CustomerId)
    } else {
      customerId = parseInt(this.props.auth.user.CustomerId)
    }

    // VALIDATION START
    let errors = []

    if (customerId === 0) {
      errors.push(translation('1736')) // please select customer
    }

    if (this.state.OrderType === '0') {
      errors.push(translation('13454')) // please select order type
    }

    if (errors.length > 0) {
      this.setErrors({
        isLoading: false
      })
      // Toastr
      let errorText = ''
      for (let i = 0; i < errors.length; i++) {
        errorText += '<br />' + errors[i]
      }
      window.toastr.error(errorText, translation('216'))
      return false
    }
    // VALIDATION END

    // IsEvaluation
    let IsEvaluation = false
    if (this.state.Estimation !== '0' && this.state.evaluationAllowed) {
      IsEvaluation = true
    }

    // Evaluation comment
    let evaluationComment = ''
    if (IsEvaluation) {
      evaluationComment = this.state.Estimation_comment
    }

    // Files
    let files = []
    if (this.state.images.length !== 0 || this.state.files.length !== 0) {
      files = [...this.state.images, ...this.state.files]
    }

    // Brand
    let BrandName = this.state.ExtraData.BrandName
    if (!BrandName) BrandName = this.state.BrandOriginal

    this.props.modal.isLoading(true)

    this.setState({ isLoading: true }, () => {
      this.props.createOrder({
        RegNr: this.state.RegNumber,
        ChassisNumber: this.state.ChassisNumber,
        OrderType: this.state.OrderType,
        BrandOriginal: this.state.ExtraData.BrandOriginal,
        Model: this.state.ExtraData.Model,
        BrandName: BrandName,
        BrandCode: this.state.ExtraData.BrandCode,
        RegistrationDate: this.state.ExtraData.RegistrationDate,
        CustomerId: parseInt(customerId),
        IsEvaluation: IsEvaluation,
        Case: {
          Comment: evaluationComment
        },
        ImageTypes: files,
        FileContainerId: this.state.fileContainerId
      }).then(res => {
        this.props.modal.isLoading(false)

        this.props.uploadImageMarkings(this.state.images)

        if (this.state.OrderType === '5' && res.data.PreviousOrders.length > 0) {
          this.setState({
            isLoading: false,
            orderdata: res.data
          }, () => this.props.updateModal({ tabView: 'complaint' }))
        } else {
          // Toastr
          // window.toastr.success(translation('13439'), translation('13424'))

          this.props.redirectToOrder(res.data.OrderId)
        }
      }, (err) => {
        this.props.modal.isLoading(false)
        this.setErrors({
          isLoading: false
        })

        // Toastr
        if (err.response.data.DictionaryKey !== undefined) {
          window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
        } else if (err.response.data.Errors !== undefined) {
          // Toastr
          let errorText = ''
          let errors = err.response.data.Errors
          for (let i = 0; i < errors.length; i++) {
            if (errors[i].StatusCode === 4) {
              this.setState({
                Estimation: '1'
              })
            }
            errorText += '<br />' + translation(errors[i].DictionaryKey)
          }
          window.toastr.error(errorText, translation('216'))
        }
      })
    })
  }

  onInputChange (e) {
    const { name, type, checked } = e.target
    let { value } = e.target

    if (type === 'checkbox') {
      if (!checked) {
        value = '0'
      }
    }
    // This prevents Paint Shop to book order with Apromas workshop customer
    if (e.target.name === 'CustomerId') {
      let customer = this.props.customers.filter(c => c.CustomerId === parseInt(e.target.value))
      if (customer.length > 0 && customer[0].IsApromasWorkshop) {
        window.toastr.error(translation('15329'), translation('216'))
        value = '0'
      }
    }
    this.setState({
      [name]: value
    })
  }

  updateState (data, cb) {
    this.setState(data, cb)
  }

  render () {
    const defaultProps = {
      updateState: this.updateState,
      onInputChange: this.onInputChange,
      updateModal: this.props.updateModal
    }

    switch (this.props.tabView) {
      case 'image':
        return <MarkImage currentImg={this.state.activeImage} images={this.state.images} {...defaultProps} />
      case 'complaint':
        return <Complaint
          listingID={this.state.listingID}
          orderdata={this.state.orderdata}
          setErrors={this.setErrors}
          redirectToOrder={this.props.redirectToOrder}
          onModalClose={this.props.onModalClose}
          {...defaultProps}
        />
      case 'draft':
        return (
          <form className='addOrderPopup clearfix' ref='addorderpopup'>
            <Forsi redirectToOrder={this.props.redirectToOrder} />
            {this.props.auth.user.CustomerId === '-1' && <Customer selected={parseInt(this.state.CustomerId)} {...defaultProps} />}
            <RegistrationNumber regNr={this.state.RegNumber} {...defaultProps} />
            <OrderTypes selected={this.state.OrderType} {...defaultProps} />
            <Brand selected={this.state.BrandOriginal} {...defaultProps} />
            <ChassisNumber chassisNumber={this.state.ChassisNumber} {...defaultProps} />
            {hasSubscriptionPermission(this.props.auth, 10) && (<FileArea
              fileContainerId={this.state.fileContainerId}
              files={this.state.files}
              images={this.state.images}
              setErrors={this.setErrors}
              {...defaultProps}
            />)}
            {hasSubscriptionPermission(this.props.auth, 30, 25) && (
              <Estimation
                evaluationAllowed={this.state.evaluationAllowed}
                showComment={this.state.Estimation === '1'}
                comment={this.state.Estimation_comment}
                {...defaultProps}
              />
            )}
          </form>
        )
    }
  }
}

NewPaintDraft.propTypes = {
  tabView: PropTypes.string.isRequired,
  uploadImageMarkings: PropTypes.func.isRequired,
  redirectToOrder: PropTypes.func.isRequired,
  updateModal: PropTypes.func.isRequired,
  modal: PropTypes.object.isRequired,
  onModalClose: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    customers: state.common.customers
  }
}

export default connect(mapStateToProps, {
  createOrder,
  getOrderVehicleData
})(NewPaintDraft)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/NewPaintDraft/index.js